<div
  class="sub-nav-item"
  [attr.data-testid]="(navItem | navItemTestId) + '-' + subItem?.relativeRouterPath"
  (click)="navItemSelected(); $event.stopPropagation()"
  [class.sub-active]="viewModel.isNavItemActive$ | async">
  {{ subItem?.name }}
  <span class="alert-indicator" *ngIf="viewModel.showNavItemAlertIndicator$ | async">&nbsp;</span>
</div>
